<template>
  <v-container id="bid-decision" fluid tag="section">
    <v-row>
      <v-col cols="12" lg="9">
        <idc-component-bid-decision-table :bid-number="bidNumber" :customer="customer" @validation="validation" />
      </v-col>
    </v-row>
    <idc-material-decision
      :icon="titleBid"
      :color="bidColor"
      title="Indicator"
      :is-bid="isBidDecision"
      :is-validated="isValid"
      :bid-number="bidNumber"
      value="+245"
      sub-icon="mdi-calendar"
      sub-text="Last 24 Hours"
      style="position: fixed; top: 190px; right: 10px; border-radius: 4px; width: 400px;"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import Path from '@/utilities/bid/enums/Path'
  import { mapState, mapActions, mapMutations } from 'vuex'

  export default Vue.extend({
    name: 'DashboardBidDecision',
    components: {
      IdcMaterialDecision: () => import('@/components/idc/bids/decision/Decision'),
      IdcComponentBidDecisionTable: () => import('@/components/idc/bids/decision/New'),
    },
    data: () => ({
      bidColor: 'red',
      titleBid: 'No Bid',
      isBidDecision: false,
      isValid: false,
    }),
    computed: {
      ...mapState('Bid', ['bidNumber', 'customer']),
    },
    async mounted() {
      if (this.bidNumber === null) {
        await this.$router.push(Path.SALES_BIDS_SUMMARY)
        return
      }

      // reset previous decision settings
      this.setBidDecisionCriteriaSets(null)

      await this.fetchDecisionSet(this.bidNumber)
    },
    methods: {
      ...mapActions('Bid', ['fetchDecisionSet']),
      ...mapMutations('Bid', ['setBidDecisionCriteriaSets']),

      validation(value) {
        this.isValid = value
      },
    },
  })
</script>

<style lang="sass">
  section#bid-decision
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important

    .v-data-table__wrapper
      overflow-x: hidden
      overflow-y: hidden

    .v-data-table__mobile-row__header
      margin-right: 20px

    table
      td
        div.col-12
          padding-top: 1px !important
          padding-bottom: 1px !important
</style>
